import { createStore, combineReducers } from 'redux'
import businessReducer from './reducers/businessReducer'
import campaignReducer from './reducers/campaignReducer' // ✅ Add this line

const rootReducer = combineReducers({
  business: businessReducer,
  campaign: campaignReducer // ✅ Add this slice
})

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

export default store
